import {
  LicenseModule,
  MakerLicense,
  MakerLicenseSummary,
} from "../Licenses.types";

export const mockMakerLicenses: MakerLicenseSummary[] = [
  {
    id: "maker-license-1",
    key: "1234-5678",
    name: "Maker License 1",
    status: "ACTIVE",
  },
  {
    id: "maker-license-2",
    key: "8765-4321",
    name: "Maker License 2",
    status: "AVAILABLE",
  },
];

const defaultParameters = [
  {
    name: "parameter",
    value: "value",
    description: "string",
  },
];

export const mockIgnitionModule: LicenseModule = {
  logoUrl: "",
  name: "Ignition Platform",
  description: "",
  identifier: "",
  currentVersion: "8.3",
  maxVersion: "8.3",
  developer: "Inductive Automation",
  parameters: [
    {
      name: "edition",
      value: "standard",
      description: "",
    },
    {
      name: "platform",
      value: "true",
      description: "",
    },
  ],
  productUrl: "",
};

const module = (
  name: string,
  description: string,
  version: string,
  developer = "Inductive Automation",
  parameters: LicenseModule["parameters"] = defaultParameters
) => ({
  logoUrl: "",
  name,
  description,
  identifier: "",
  currentVersion: version,
  maxVersion: version,
  developer,
  parameters,
  productUrl: "string",
});

export const mockDataForLicense = (licenseId: string): MakerLicense => ({
  ...mockMakerLicenses[0],
  ...mockMakerLicenses.find((license) => license.id === licenseId),

  createdAt: new Date("2024-08-01T17:51:43.380Z"),
  lastModifiedAt: new Date("2024-08-01T17:51:43.380Z"),
  version: "string",
  edition: "[Edition]",
  activationMethod: "string",
  sessions: [
    {
      id: "session-1",
      name: "Gateway Name",
      ipAddress: "000.000.000.000",
      lastSeen: new Date("2024-08-03T17:51:43.380Z"),
      validated: new Date("2024-08-01T17:51:43.380Z"),
      invalidated: new Date("2024-08-22T17:51:43.380Z"),
      nextCheckIn: new Date("2024-08-02T17:51:43.380Z"),
      expiration: new Date("2024-08-02T17:51:43.380Z"),
      status: "INVALID",
    },
    {
      id: "session-2",
      name: "Gateway Name",
      ipAddress: "000.000.000.000",
      lastSeen: new Date("2024-08-04T17:51:43.380Z"),
      validated: new Date("2024-08-02T17:51:43.380Z"),
      invalidated: new Date("2024-08-04T17:51:43.380Z"),
      nextCheckIn: new Date("2024-08-03T17:51:43.380Z"),
      expiration: new Date("2024-08-03T17:51:43.380Z"),
      status: "INVALID",
    },
    {
      id: "session-3",
      name: "Gateway Name",
      ipAddress: "000.000.000.000",
      lastSeen: new Date("2024-08-05T17:51:43.380Z"),
      validated: new Date("2024-08-01T17:51:43.380Z"),
      nextCheckIn: new Date("2024-08-07T17:51:43.380Z"),
      expiration: new Date("2024-08-08T17:51:43.380Z"),
      status: "VALID",
    },
  ],
  coreModules: [
    {
      logoUrl: "",
      name: "Alarm Notification Module",
      description: "com.inductiveautomation.alarm-notification",
      identifier: "",
      currentVersion: "8.1",
      maxVersion: "8.1",
      developer: "Inductive Automation",
      parameters: [
        {
          name: "parameter",
          value: "value",
          description: "string",
        },
      ],
      productUrl: "string",
    },
    module(
      "Twilio Notification Module",
      "com.inductiveautomation.twilio",
      "8.3"
    ),
    module("OPC UA Module", "com.inductiveautomation.opcua", "8.1"),
    module(
      "Perspective Module",
      "com.inductiveautomation.perspective",
      "7.9",
      "Inductive Automation",
      [
        {
          name: "browser",
          value: "true",
          description: "string",
        },
        {
          name: "edition",
          value: "standard",
          description: "string",
        },
        {
          name: "mobile",
          value: "true",
          description: "string",
        },
        {
          name: "Workstation",
          value: "true",
          description: "string",
        },
      ]
    ),
    module("Reporting Module", "com.inductiveautomation.reporting", "8.3"),
    module("SQL Bridge Module", "com.inductiveautomation.sqlbridge", "7.7"),
    module(
      "Tag Historian Module",
      "com.inductiveautomation.taghistorian",
      "7.8"
    ),
    module(
      "Sequential Function Chargs (SFC) Module",
      "com.inductiveautomation.sfc",
      "7.6"
    ),
    module(
      "Serial Module – Client",
      "com.inductiveautomation.serial-support-client",
      "8.1"
    ),
    module("Web Development Module", "com.inductiveautomation.webdev", "7.7"),
  ],
  thirdPartyModules: [
    module("MQTT Engine Module", "com.cirruslink.", "8.1", "Cirrus Link"),
    module("MQTT Distributor Module", "com.cirruslink.", "7.9", "Cirrus Link"),
    module("MQTT Transmission Module", "com.cirruslink.", "8.3", "Cirrus Link"),
  ],
  activity: [
    {
      id: "activity-item-1",
      title: "string",
      description: "string",
      timestamp: new Date("2024-08-01T17:51:43.380Z"),
      user: {
        id: "user-1",
        firstName: "string",
        lastName: "string",
        primaryEmailAddress: "email@example.com",
      },
      eventType: "SUCCESS",
    },
  ],
});
